import { render, staticRenderFns } from "./TariffDetails.vue?vue&type=template&id=1747fbe0&scoped=true"
import script from "./TariffDetails.vue?vue&type=script&lang=js"
export * from "./TariffDetails.vue?vue&type=script&lang=js"
import style0 from "./TariffDetails.vue?vue&type=style&index=0&id=1747fbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747fbe0",
  null
  
)

export default component.exports